import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import s, { getFontFamily } from './Typography.styles';

export type Caption1Props = RNTextProps & {
  weight?: 'regular' | 'medium' | 'semibold';
  uppercase?: boolean;
};

export const Caption1: React.FC<Caption1Props> = ({
  children,
  weight = 'regular',
  uppercase = false,
  style,
  ...props
}) => {
  return (
    <RNText
      style={[
        s.common,
        s.caption1,
        uppercase && s.caption1Caps,
        {
          textTransform: uppercase ? 'uppercase' : 'none',
        },
        getFontFamily(weight),
        style,
      ]}
      {...props}
    >
      {children}
    </RNText>
  );
};
